import { Fragment } from 'react'

const URL_RE = /(https?:\/\/[^\s<>()]+[^\s<>().,;:!?'"])/g

/**
 * „Markdown-light" für Termin-Beschreibungen (ADR-090): Zeilenumbrüche bleiben,
 * http(s)-Links werden klickbar. Bewusst KEIN HTML-Rendering (kein XSS-Risiko,
 * auch nicht aus Abo-Feeds) — nur Text und <a>.
 */
export function RichText({ text, className }: { text: string; className?: string }): React.JSX.Element {
  return (
    <div className={`whitespace-pre-wrap break-words ${className ?? ''}`}>
      {text.split(URL_RE).map((part, i) =>
        i % 2 === 1 ? (
          <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="underline" style={{ color: 'var(--color-accent)' }}>
            {part}
          </a>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </div>
  )
}

/** Enthält der Text mindestens einen Link? */
export function hasLink(text: string): boolean {
  return /https?:\/\//.test(text)
}
